import React from 'react';
import { Card, CardContent } from './ui/card';
import { Mic2, Sliders, Disc3, Music2, Check } from 'lucide-react';
import { services } from '../mock';

const iconMap = {
  Mic2: Mic2,
  Sliders: Sliders,
  Disc3: Disc3,
  Music2: Music2
};

const Services = () => {
  return (
    <section id="services" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-orange-600 font-semibold text-sm uppercase tracking-wide">
            Nos Services
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mt-3 mb-4">
            Excellence à chaque étape
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            De l'enregistrement à la finalisation, nous offrons une gamme complète de services professionnels
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service) => {
            const IconComponent = iconMap[service.icon];
            return (
              <Card
                key={service.id}
                className="group border-2 border-gray-100 hover:border-orange-500 transition-all duration-300 hover:shadow-xl"
              >
                <CardContent className="p-6">
                  <div className="bg-orange-50 w-14 h-14 rounded-lg flex items-center justify-center mb-4 group-hover:bg-orange-600 transition-colors duration-300">
                    <IconComponent className="w-7 h-7 text-orange-600 group-hover:text-white transition-colors duration-300" />
                  </div>
                  
                  <h3 className="text-xl font-bold text-gray-900 mb-3">
                    {service.title}
                  </h3>
                  
                  <p className="text-gray-600 mb-4">
                    {service.description}
                  </p>

                  <ul className="space-y-2">
                    {service.features.map((feature, index) => (
                      <li key={index} className="flex items-start text-sm text-gray-700">
                        <Check className="w-4 h-4 text-orange-600 mr-2 mt-0.5 flex-shrink-0" />
                        <span>{feature}</span>
                      </li>
                    ))}
                  </ul>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Equipment Section */}
        <div className="mt-24">
          <div className="bg-gradient-to-br from-orange-50 to-orange-100/50 rounded-2xl p-8 md:p-12">
            <div className="grid md:grid-cols-2 gap-12 items-center">
              <div>
                <h3 className="text-3xl font-bold text-gray-900 mb-4">
                  Équipement de pointe
                </h3>
                <p className="text-lg text-gray-700 mb-6">
                  Notre studio est équipé avec les meilleurs outils de l'industrie pour garantir
                  une qualité sonore exceptionnelle à chaque projet.
                </p>
                <div className="grid grid-cols-2 gap-4">
                  <div className="bg-white rounded-lg p-4 shadow-sm">
                    <div className="text-2xl font-bold text-orange-600 mb-1">SSL</div>
                    <div className="text-sm text-gray-600">Console AWS 948</div>
                  </div>
                  <div className="bg-white rounded-lg p-4 shadow-sm">
                    <div className="text-2xl font-bold text-orange-600 mb-1">Neumann</div>
                    <div className="text-sm text-gray-600">Microphones U87</div>
                  </div>
                  <div className="bg-white rounded-lg p-4 shadow-sm">
                    <div className="text-2xl font-bold text-orange-600 mb-1">Genelec</div>
                    <div className="text-sm text-gray-600">Monitoring 8351B</div>
                  </div>
                  <div className="bg-white rounded-lg p-4 shadow-sm">
                    <div className="text-2xl font-bold text-orange-600 mb-1">Pro Tools</div>
                    <div className="text-sm text-gray-600">HDX System</div>
                  </div>
                </div>
              </div>
              <div className="relative">
                <img
                  src="https://images.unsplash.com/photo-1531651008558-ed1740375b39?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHw0fHxyZWNvcmRpbmclMjBzdHVkaW98ZW58MHx8fHwxNzc0MzM1MDE5fDA&ixlib=rb-4.1.0&q=85"
                  alt="Professional Studio Equipment"
                  className="rounded-xl shadow-2xl"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
